export default {
  saveMenu: '/authorize-service/authorize/menu/saveMenu',
  deleteMenu: '/authorize-service/authorize/menu/deleteMenu',
  editMenu: '/authorize-service/authorize/menu/editMenu',
  selectMenuByPage: '/authorize-service/authorize/menu/selectMenuByPage',
  selectMenuById: '/authorize-service/authorize/menu/selectMenuById',
  selectMenuByPermission: '/authorize-service/authorize/menu/selectMenuByPermission'
}



// WEBPACK FOOTER //
// ./src/config/authority/menu/index.js